import { Component } from '@angular/core';

@Component({
  selector: 'app-users-menu-list',
  standalone: true,
  imports: [],
  templateUrl: './users-menu-list.component.html',
  styleUrl: './users-menu-list.component.css'
})
export class UsersMenuListComponent {

}
